import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Extremes} from "../model/asax-frequency-view.model";

@Injectable({
  providedIn: 'root'
})
export class AsaxFrequencyViewService {
  private readonly extremesSubject = new Subject<Extremes>();
  private readonly redshiftEstimatedSubject = new BehaviorSubject<number>(undefined);
  private readonly zoomExtremesSubject = new BehaviorSubject<Extremes>(undefined);
  private readonly resetExtremesSubject = new BehaviorSubject<Extremes>(undefined);
  private readonly rowsTableExtremes = new BehaviorSubject<Extremes>(undefined);

  getResetExtremes(): Observable<Extremes> {
    return this.resetExtremesSubject.asObservable();
  }

  setResetExtremes(extremes: Extremes): void {
    this.resetExtremesSubject.next(extremes);
  }

  getRowsTableExtremes(): Observable<Extremes> {
    return this.rowsTableExtremes.asObservable();
  }

  setRowsTableExtremes(extremes: Extremes): void {
    this.rowsTableExtremes.next({...extremes});
  }

  getZoomExtremes(): Observable<Extremes> {
    return this.zoomExtremesSubject.asObservable();
  }

  setZoomExtremes(extremes: Extremes): void {
    this.zoomExtremesSubject.next(extremes);
  }

  getExtremes(): Observable<Extremes> {
    return this.extremesSubject.asObservable();
  }

  setExtremes(extremes: Extremes): void {
    this.extremesSubject.next(extremes);
  }

  getRedshiftEstimated(): Observable<number> {
    return this.redshiftEstimatedSubject.asObservable();
  }

  setRedshiftEstimated(redshift: number): void {
    this.redshiftEstimatedSubject.next(redshift);
  }
}
